import AdjustmentManager from "@/pages/adjustments/manager";
import AdjustmentReport from "@/pages/adjustments/report";

export const routeAdjustmentManager = "/adjustments/manager";
export const routeAdjustmentReport = "/adjustments/report";

export const adjustmentRoutes = [
	{
		path: `${routeAdjustmentManager}`,
		element: <AdjustmentManager />,
		permission: "ui.navbar.adjustments.manager",
	},
	{
		path: `${routeAdjustmentManager}/:shiftId`,
		element: <AdjustmentManager />,
		permission: "ui.navbar.adjustments.manager",
	},
	{
		path: `${routeAdjustmentReport}`,
		element: <AdjustmentReport />,
		permission: "ui.navbar.adjustments.report",
	},
];
